/** `data-agent` namespace dictionaries for the database workbench. */

/** Dictionary namespace owned by this plugin. */
export const NS = 'data-agent'

/** Simplified Chinese dictionary (the key-set source of truth). */
export const zh = {
  'form.title': '数据库连接',
  'form.hero.title': '连接数据库',
  'form.hero.hint': '连接 MySQL / PostgreSQL / SQLite 等，开始与数据 Agent 对话',
  'form.type': '数据库类型',
  'type.mysql': 'MySQL',
  'type.postgres': 'PostgreSQL',
  'type.sqlite': 'SQLite',
  'type.oracle': 'Oracle',
  'type.hive': 'Hive',
  'type.impala': 'Impala',
  'type.clickhouse': 'ClickHouse',
  'type.doris': 'Apache Doris',
  'type.sqlserver': 'SQL Server',
  'form.host': '主机',
  'form.port': '端口',
  'form.user': '用户名',
  'form.password': '密码',
  'form.credentialMode': '凭据方式',
  'form.credentialMode.password': '临时密码',
  'form.credentialMode.reference': 'Credential reference（推荐）',
  'form.passwordRef': '凭据引用',
  'form.passwordRef.hint': '仅保存引用名称；执行时由 DSH credentials 解析',
  'credential.configured': '凭据已配置',
  'credential.unconfigured': '凭据未配置',
  'form.rememberPassword': '记住密码',
  'form.rememberPassword.hint': '仅勾选后才会在本机保存密码',
  'form.readonly': '只读模式',
  'form.readonly.hint': '仅放行查询语句，拒绝增删改、建表等写操作',
  'form.secure': '使用HTTPS',
  'form.secure.hint': '使用8443默认端口并验证服务器证书',
  'form.database': '数据库名',
  'form.database.oracle': '服务名 / SID',
  'form.database.hive': '默认库',
  'form.database.impala': '默认库',
  'form.database.sqlite': '数据库文件路径',
  'form.database.sqlite.placeholder': '/path/to/orders.db',
  'action.connect': '连接',
  'action.disconnect': '断开',
  'state.connected': '已连接',
  'state.disconnected': '未连接',
  'state.checking': '正在检查连接…',
  'state.reconnecting': '正在恢复连接…',
  'state.reconnectRequired': '需要重新认证',
  'workbench.open.connected': '数据库工作台：已连接',
  'workbench.open.disconnected': '数据库工作台：未连接',
  'workbench.open.checking': '数据库工作台：正在检查连接',
  'workbench.open.error': '数据库工作台：连接异常',
  'workbench.open.reconnectRequired': '数据库工作台：需要重新认证',
  'composer.placeholder.disconnected': '数据库未连接，请点击输入框右上角的配置按钮',
  'composer.placeholder.connected': '数据库连接成功，请描述分析内容',
  'composer.placeholder.reconnectRequired': '数据库需要重新认证，请点击输入框右上角的配置按钮',
  'wb.workbench.title': '数据库工作台',
  'wb.workbench.description': '管理连接、浏览库表并运行 SQL',
  'wb.workbench.tabs': '数据库工作台功能',
  'wb.schemas': '库',
  'wb.tables': '表',
  'wb.columns': '表结构',
  'wb.sql': 'SQL 命令',
  'wb.sql.placeholder': '在此输入 SQL，例如 SELECT * FROM orders LIMIT 10;',
  'wb.sql.placeholder.sqlserver': '在此输入 T-SQL，例如 SELECT TOP (10) * FROM orders;',
  'wb.sql.run': '运行',
  'wb.sql.running': '运行中…',
  'wb.sql.shortcut': 'Ctrl / ⌘ + Enter 运行',
  'wb.sql.empty': '运行查询后，结果会显示在这里',
  'wb.sql.result.summary': '{rows} 行 · {columns} 列 · {elapsed} ms',
  'wb.sql.result.capped': '仅保留前 {rows} 行',
  'wb.sql.result.outputTruncated': '… 输出超过大小上限，已截断',
  'wb.sql.result.table': 'SQL 查询结果',
  'wb.sql.result.noRows': '查询成功，无返回行',
  'wb.sql.command.done': '命令执行成功',
  'wb.sql.export.actions': '结果导出',
  'wb.sql.export.excel': 'Excel',
  'wb.sql.export.csv': 'CSV',
  'wb.sql.export.clipboard': '复制',
  'wb.sql.exporting': '生成中…',
  'wb.sql.copying': '复制中…',
  'wb.sql.export.done': '已导出 {rows} 行',
  'wb.sql.copy.done': '已复制 {rows} 行',
  'wb.sql.export.failed': '导出失败：{detail}',
  'wb.sql.page.summary': '第 {page} / {pages} 页',
  'wb.sql.page.previous': '上一页',
  'wb.sql.page.next': '下一页',
  'wb.loading': '加载中…',
  'wb.empty': '（空）',
  'wb.modal.title': '库表浏览',
  'wb.hint.click': '单击库展开表 · 点击表查看结构',
  'action.config': '连接配置',
  'action.browse': '库表',
  'action.catalog': '数据治理',
  'catalog.source': '数据源',
  'catalog.source.current': '当前连接（尚未扫描）',
  'catalog.empty': '尚无数据目录。连接数据库后执行首次扫描。',
  'catalog.search': '搜索表、字段、术语或指标',
  'catalog.schema': 'Schema',
  'catalog.schema.filter': 'Schema 筛选',
  'catalog.table': '表或视图',
  'catalog.validation.schema': '请输入 Schema。',
  'catalog.validation.table': '请输入 Schema 和表或视图。',
  'catalog.filter.all': '全部类型',
  'catalog.filter.tables': '表与视图',
  'catalog.filter.review': '包含待确认口径',
  'catalog.filter.assetStatus': '全部资产状态',
  'catalog.filter.semanticStatus': '全部口径状态',
  'catalog.scan': '扫描',
  'catalog.scan.all': '全库',
  'catalog.scan.schema': 'Schema',
  'catalog.scan.table': '单表',
  'catalog.scan.confirm': '确认扫描整个数据源？该操作只读取系统元数据，但可能耗时较长。',
  'catalog.section.scan': '扫描范围',
  'catalog.section.diff': '版本对比',
  'catalog.cancel': '取消扫描',
  'catalog.diff': '查看变更',
  'catalog.diff.from': '起始成功扫描',
  'catalog.diff.to': '目标成功扫描',
  'catalog.refresh': '刷新',
  'catalog.loadMore': '加载更多',
  'catalog.status.never': '尚未扫描',
  'catalog.status.latest': '最近扫描',
  'catalog.status.full': '最近全库扫描',
  'catalog.status.partial': '最近局部扫描',
  'catalog.status.failureReason': '失败原因：',
  'catalog.count.assets': '资产',
  'catalog.count.fields': '字段',
  'catalog.count.review': '待确认',
  'catalog.progress': '{schemas} Schema · {relations} 表/视图 · {fields} 字段',
  'catalog.enrichment.label': 'AI 业务含义',
  'catalog.enrichment.progress': '已完成 {completed}/{total} 张表 · {candidates} 个候选',
  'catalog.enrichment.queued': '等待 AI 生成',
  'catalog.enrichment.running': 'AI 正在逐表生成业务含义',
  'catalog.enrichment.succeeded': 'AI 业务含义生成成功',
  'catalog.enrichment.partial': 'AI 业务含义部分成功',
  'catalog.enrichment.failed': 'AI 业务含义生成失败',
  'catalog.enrichment.cancelled': 'AI 业务含义生成已取消',
  'catalog.detail.technical': '技术结构',
  'catalog.detail.business': '业务定义',
  'catalog.detail.history': '变更历史',
  'catalog.detail.relations': '键、索引与关系',
  'catalog.detail.provenance': '来源',
  'catalog.detail.run': '扫描运行',
  'catalog.detail.name': '名称',
  'catalog.detail.type': '类型',
  'catalog.detail.nullable': '可空',
  'catalog.detail.parentTable': '所属表',
  'catalog.detail.select': '选择一个资产或业务定义查看详情',
  'catalog.detail.summary': '资产摘要',
  'catalog.detail.fields': '字段',
  'catalog.detail.relationCount': '关系',
  'catalog.detail.definitionCount': '业务定义',
  'catalog.detail.scanFacts': '扫描信息与能力',
  'catalog.detail.yes': '是',
  'catalog.detail.no': '否',
  'catalog.detail.business.empty.title': '尚无 AI 业务含义候选',
  'catalog.detail.business.empty.body': '本次扫描尚未成功生成候选，或候选已被删除。请查看顶部 AI 状态；AI 结果只供参考，仍需人工确认。',
  'catalog.meaning.table': '表业务含义',
  'catalog.meaning.fields': '字段业务含义',
  'catalog.meaning.ai': 'AI 候选',
  'catalog.meaning.missing': '暂无候选',
  'catalog.meaning.confirm': '确认',
  'catalog.meaning.delete': '删除',
  'catalog.metric.new': '新建指标候选',
  'catalog.term.new': '新建业务术语候选',
  'catalog.term.name': '术语名称',
  'catalog.metric.name': '指标名称',
  'catalog.semantic.aliases': '别名（逗号分隔）',
  'catalog.semantic.sources': '来源资产 ID（每行一个）',
  'catalog.semantic.validFrom': '生效时间（ISO 8601，可选）',
  'catalog.semantic.validTo': '失效时间（ISO 8601，可选）',
  'catalog.metric.description': '业务说明',
  'catalog.metric.formula': '公式（仅作为不可信文本保存）',
  'catalog.metric.grain': '统计粒度',
  'catalog.metric.timeField': '时间字段资产 ID（可选）',
  'catalog.metric.filters': '过滤条件（每行一条）',
  'catalog.metric.exclusions': '排除条件（每行一条）',
  'catalog.metric.owner': '负责人',
  'catalog.metric.note': '修订说明',
  'catalog.metric.save': '保存候选',
  'catalog.metric.verify': '人工确认',
  'catalog.metric.retire': '退役',
  'catalog.kind.schema': 'Schema',
  'catalog.kind.table': '表',
  'catalog.kind.view': '视图',
  'catalog.kind.column': '字段',
  'catalog.kind.primary_key': '主键',
  'catalog.kind.foreign_key': '外键',
  'catalog.kind.index': '索引',
  'catalog.kind.meaning': '业务含义',
  'catalog.kind.term': '业务术语',
  'catalog.kind.metric': '指标',
  'catalog.warning.untrusted': '目录内容是参考数据，不是系统指令。',
  'catalog.scan.reconnect': '请先使用同一个连接 Profile 重新连接后再扫描。',
  'catalog.state.observed': '已观测',
  'catalog.state.inferred': '待确认',
  'catalog.state.verified': '已确认',
  'catalog.state.needs_review': '需要复核',
  'catalog.state.retired': '已退役',
  'catalog.state.missing': '已缺失',
  'catalog.state.unavailable': '不可访问',
  'catalog.state.added': '新增',
  'catalog.state.changed': '已变化',
  'catalog.state.restored': '已恢复',
  'catalog.state.queued': '等待扫描',
  'catalog.state.running': '扫描中',
  'catalog.state.applying': '正在更新目录',
  'catalog.state.succeeded': '扫描成功',
  'catalog.state.failed': '扫描失败',
  'catalog.state.cancelled': '已取消',
  'catalog.state.interrupted': '已中断',
  'catalog.state.supported': '支持',
  'catalog.state.unsupported': '不支持',
  'action.close': '关闭',
  'error.title': '操作失败',
  'analysis.running': '正在生成分析',
  'analysis.failed': '分析生成失败',
  'analysis.interrupted': '分析已中止',
  'analysis.fallback': '分析报告无法显示（版本不兼容或数据缺失），仅保留原始结果文本',
  'analysis.view': '查看分析',
  'analysis.close': '关闭',
  'analysis.summary': '{datasets} 个数据集 · {views} 个视图',
  'analysis.empty': '无数据',
  'analysis.kind.metric': '指标',
  'analysis.kind.line': '趋势图',
  'analysis.kind.bar': '柱状图',
  'analysis.kind.pie': '饼图',
  'analysis.kind.scatter': '散点图',
  'analysis.kind.table': '明细表',
  'analysis.chart.summary': '{kind}：{label}，共 {rows} 行数据',
  'analysis.metric.null': '—',
  'analysis.row.title': 'render-analysis',
} satisfies Record<string, string>

/** The data-agent namespace key union. */
export type DataAgentKey = keyof typeof zh

/** English dictionary, checked complete against the zh key set. */
export const en = {
  'form.title': 'Database connection',
  'form.hero.title': 'Connect database',
  'form.hero.hint': 'Connect MySQL / PostgreSQL / SQLite and start chatting with the data agent',
  'form.type': 'Database type',
  'type.mysql': 'MySQL',
  'type.postgres': 'PostgreSQL',
  'type.sqlite': 'SQLite',
  'type.oracle': 'Oracle',
  'type.hive': 'Hive',
  'type.impala': 'Impala',
  'type.clickhouse': 'ClickHouse',
  'type.doris': 'Apache Doris',
  'type.sqlserver': 'SQL Server',
  'form.host': 'Host',
  'form.port': 'Port',
  'form.user': 'User',
  'form.password': 'Password',
  'form.credentialMode': 'Credential mode',
  'form.credentialMode.password': 'Temporary password',
  'form.credentialMode.reference': 'Credential reference (recommended)',
  'form.passwordRef': 'Credential reference',
  'form.passwordRef.hint': 'Only the reference is saved; DSH credentials resolves it per operation',
  'credential.configured': 'Credential configured',
  'credential.unconfigured': 'Credential not configured',
  'form.rememberPassword': 'Remember password',
  'form.rememberPassword.hint': 'Saved locally only when checked',
  'form.readonly': 'Read-only mode',
  'form.readonly.hint': 'Allow read queries only; reject writes (INSERT/UPDATE/DELETE/DDL)',
  'form.secure': 'Use HTTPS',
  'form.secure.hint': 'Use default port 8443 and verify the server certificate',
  'form.database': 'Database',
  'form.database.oracle': 'Service name / SID',
  'form.database.hive': 'Default database',
  'form.database.impala': 'Default database',
  'form.database.sqlite': 'Database file path',
  'form.database.sqlite.placeholder': '/path/to/orders.db',
  'action.connect': 'Connect',
  'action.disconnect': 'Disconnect',
  'state.connected': 'Connected',
  'state.disconnected': 'Not connected',
  'state.checking': 'Checking connection…',
  'state.reconnecting': 'Restoring connection…',
  'state.reconnectRequired': 'Authentication required',
  'workbench.open.connected': 'Database workbench: connected',
  'workbench.open.disconnected': 'Database workbench: not connected',
  'workbench.open.checking': 'Database workbench: checking connection',
  'workbench.open.error': 'Database workbench: connection error',
  'workbench.open.reconnectRequired': 'Database workbench: authentication required',
  'composer.placeholder.disconnected': 'Database not connected. Click the configuration button at the top right of the input box.',
  'composer.placeholder.connected': 'Database connected. Describe what you want to analyze.',
  'composer.placeholder.reconnectRequired': 'Database authentication required. Click the configuration button at the top right of the input box.',
  'wb.workbench.title': 'Database workbench',
  'wb.workbench.description': 'Manage connections, browse schemas, and run SQL',
  'wb.workbench.tabs': 'Database workbench sections',
  'wb.schemas': 'Databases',
  'wb.tables': 'Tables',
  'wb.columns': 'Columns',
  'wb.sql': 'SQL',
  'wb.sql.placeholder': 'Write SQL here, e.g. SELECT * FROM orders LIMIT 10;',
  'wb.sql.placeholder.sqlserver': 'Write T-SQL here, e.g. SELECT TOP (10) * FROM orders;',
  'wb.sql.run': 'Run',
  'wb.sql.running': 'Running…',
  'wb.sql.shortcut': 'Ctrl / ⌘ + Enter to run',
  'wb.sql.empty': 'Run a query to see its result here',
  'wb.sql.result.summary': '{rows} rows · {columns} columns · {elapsed} ms',
  'wb.sql.result.capped': 'Limited to the first {rows} rows',
  'wb.sql.result.outputTruncated': '… output exceeded the size limit and was truncated',
  'wb.sql.result.table': 'SQL query result',
  'wb.sql.result.noRows': 'Query succeeded with no rows',
  'wb.sql.command.done': 'Command completed successfully',
  'wb.sql.export.actions': 'Result exports',
  'wb.sql.export.excel': 'Excel',
  'wb.sql.export.csv': 'CSV',
  'wb.sql.export.clipboard': 'Copy',
  'wb.sql.exporting': 'Creating…',
  'wb.sql.copying': 'Copying…',
  'wb.sql.export.done': 'Exported {rows} rows',
  'wb.sql.copy.done': 'Copied {rows} rows',
  'wb.sql.export.failed': 'Export failed: {detail}',
  'wb.sql.page.summary': 'Page {page} of {pages}',
  'wb.sql.page.previous': 'Previous',
  'wb.sql.page.next': 'Next',
  'wb.loading': 'Loading…',
  'wb.empty': '(empty)',
  'wb.modal.title': 'Database explorer',
  'wb.hint.click': 'Click a database to expand tables · click a table for columns',
  'action.config': 'Connection settings',
  'action.browse': 'Tables',
  'action.catalog': 'Data Governance',
  'catalog.source': 'Source',
  'catalog.source.current': 'Current connection (not scanned yet)',
  'catalog.empty': 'No Catalog snapshot yet. Connect a database and run the first scan.',
  'catalog.search': 'Search tables, columns, terms, or metrics',
  'catalog.schema': 'Schema',
  'catalog.schema.filter': 'Schema filter',
  'catalog.table': 'Table or view',
  'catalog.validation.schema': 'Enter a schema.',
  'catalog.validation.table': 'Enter both a schema and a table or view.',
  'catalog.filter.all': 'All kinds',
  'catalog.filter.tables': 'Tables and views',
  'catalog.filter.review': 'Include unverified definitions',
  'catalog.filter.assetStatus': 'All asset states',
  'catalog.filter.semanticStatus': 'All definition states',
  'catalog.scan': 'Scan',
  'catalog.scan.all': 'Full source',
  'catalog.scan.schema': 'Schema',
  'catalog.scan.table': 'Single table',
  'catalog.scan.confirm': 'Scan the entire source? Only system metadata is read, but this may take time.',
  'catalog.section.scan': 'Scan scope',
  'catalog.section.diff': 'Compare versions',
  'catalog.cancel': 'Cancel scan',
  'catalog.diff': 'View changes',
  'catalog.diff.from': 'From successful scan',
  'catalog.diff.to': 'To successful scan',
  'catalog.refresh': 'Refresh',
  'catalog.loadMore': 'Load more',
  'catalog.status.never': 'Never scanned',
  'catalog.status.latest': 'Latest scan',
  'catalog.status.full': 'Last full scan',
  'catalog.status.partial': 'Last partial scan',
  'catalog.status.failureReason': 'Failure reason:',
  'catalog.count.assets': 'Assets',
  'catalog.count.fields': 'Fields',
  'catalog.count.review': 'To review',
  'catalog.progress': '{schemas} schemas · {relations} tables/views · {fields} fields',
  'catalog.enrichment.label': 'AI business meanings',
  'catalog.enrichment.progress': '{completed}/{total} tables complete · {candidates} candidates',
  'catalog.enrichment.queued': 'Waiting for AI generation',
  'catalog.enrichment.running': 'AI is generating meanings table by table',
  'catalog.enrichment.succeeded': 'AI business meanings succeeded',
  'catalog.enrichment.partial': 'AI business meanings partially succeeded',
  'catalog.enrichment.failed': 'AI business meaning generation failed',
  'catalog.enrichment.cancelled': 'AI business meaning generation cancelled',
  'catalog.detail.technical': 'Technical structure',
  'catalog.detail.business': 'Business definitions',
  'catalog.detail.history': 'Change history',
  'catalog.detail.relations': 'Keys, indexes, and relations',
  'catalog.detail.provenance': 'Provenance',
  'catalog.detail.run': 'Scan run',
  'catalog.detail.name': 'Name',
  'catalog.detail.type': 'Type',
  'catalog.detail.nullable': 'Nullable',
  'catalog.detail.parentTable': 'Parent table',
  'catalog.detail.select': 'Select an asset or definition to view details',
  'catalog.detail.summary': 'Asset summary',
  'catalog.detail.fields': 'Fields',
  'catalog.detail.relationCount': 'Relations',
  'catalog.detail.definitionCount': 'Definitions',
  'catalog.detail.scanFacts': 'Scan facts and capabilities',
  'catalog.detail.yes': 'Yes',
  'catalog.detail.no': 'No',
  'catalog.detail.business.empty.title': 'No AI business-meaning candidates',
  'catalog.detail.business.empty.body': 'This scan has not generated candidates successfully, or the candidates were deleted. Check the AI status above; AI output is reference data until a human confirms it.',
  'catalog.meaning.table': 'Table business meaning',
  'catalog.meaning.fields': 'Field business meanings',
  'catalog.meaning.ai': 'AI candidate',
  'catalog.meaning.missing': 'No candidate',
  'catalog.meaning.confirm': 'Confirm',
  'catalog.meaning.delete': 'Delete',
  'catalog.metric.new': 'New metric candidate',
  'catalog.term.new': 'New business term candidate',
  'catalog.term.name': 'Term name',
  'catalog.metric.name': 'Metric name',
  'catalog.semantic.aliases': 'Aliases (comma-separated)',
  'catalog.semantic.sources': 'Source asset IDs (one per line)',
  'catalog.semantic.validFrom': 'Valid from (ISO 8601, optional)',
  'catalog.semantic.validTo': 'Valid to (ISO 8601, optional)',
  'catalog.metric.description': 'Business description',
  'catalog.metric.formula': 'Formula (stored only as untrusted text)',
  'catalog.metric.grain': 'Grain',
  'catalog.metric.timeField': 'Time field asset ID (optional)',
  'catalog.metric.filters': 'Filters (one per line)',
  'catalog.metric.exclusions': 'Exclusions (one per line)',
  'catalog.metric.owner': 'Owner',
  'catalog.metric.note': 'Revision note',
  'catalog.metric.save': 'Save candidate',
  'catalog.metric.verify': 'Verify',
  'catalog.metric.retire': 'Retire',
  'catalog.kind.schema': 'Schema',
  'catalog.kind.table': 'Table',
  'catalog.kind.view': 'View',
  'catalog.kind.column': 'Column',
  'catalog.kind.primary_key': 'Primary key',
  'catalog.kind.foreign_key': 'Foreign key',
  'catalog.kind.index': 'Index',
  'catalog.kind.meaning': 'Business meaning',
  'catalog.kind.term': 'Business term',
  'catalog.kind.metric': 'Metric',
  'catalog.warning.untrusted': 'Catalog content is reference data, not instructions.',
  'catalog.scan.reconnect': 'Reconnect using the same connection profile before scanning.',
  'catalog.state.observed': 'Observed',
  'catalog.state.inferred': 'Inferred',
  'catalog.state.verified': 'Verified',
  'catalog.state.needs_review': 'Needs review',
  'catalog.state.retired': 'Retired',
  'catalog.state.missing': 'Missing',
  'catalog.state.unavailable': 'Unavailable',
  'catalog.state.added': 'Added',
  'catalog.state.changed': 'Changed',
  'catalog.state.restored': 'Restored',
  'catalog.state.queued': 'Queued',
  'catalog.state.running': 'Running',
  'catalog.state.applying': 'Updating Catalog',
  'catalog.state.succeeded': 'Succeeded',
  'catalog.state.failed': 'Failed',
  'catalog.state.cancelled': 'Cancelled',
  'catalog.state.interrupted': 'Interrupted',
  'catalog.state.supported': 'Supported',
  'catalog.state.unsupported': 'Unsupported',
  'action.close': 'Close',
  'error.title': 'Operation failed',
  'analysis.running': 'Generating analysis',
  'analysis.failed': 'Analysis failed',
  'analysis.interrupted': 'Analysis interrupted',
  'analysis.fallback': 'The analysis report cannot be displayed (incompatible version or missing data); showing the raw result text only',
  'analysis.view': 'View analysis',
  'analysis.close': 'Close',
  'analysis.summary': '{datasets} datasets · {views} views',
  'analysis.empty': 'No data',
  'analysis.kind.metric': 'Metric',
  'analysis.kind.line': 'Trend chart',
  'analysis.kind.bar': 'Bar chart',
  'analysis.kind.pie': 'Pie chart',
  'analysis.kind.scatter': 'Scatter chart',
  'analysis.kind.table': 'Table',
  'analysis.chart.summary': '{kind}: {label}, {rows} rows',
  'analysis.metric.null': '—',
  'analysis.row.title': 'render-analysis',
} satisfies Record<DataAgentKey, string>
